export default "__VITE_ASSET__hKu248yt__"